module.exports = __webpack_public_path__ + "img/01.8eabd0c4.jpg";